export function getApiMessageKey(payload) {
  if (!payload || typeof payload !== "object") return "";
  return (
    payload.messageKey ||
    payload.message_key ||
    payload.errorKey ||
    payload.error_key ||
    ""
  );
}

export function getApiMessageParams(payload) {
  if (!payload || typeof payload !== "object") return undefined;
  const params = payload.messageParams || payload.message_params;
  if (!params || typeof params !== "object" || Array.isArray(params)) {
    return undefined;
  }
  return params;
}

export function normalizeApiMessage(payload, fallback = "") {
  if (!payload || typeof payload !== "object") {
    return {
      message: fallback,
      messageKey: "",
      messageParams: undefined,
    };
  }

  return {
    message: payload.message || fallback || "",
    messageKey: getApiMessageKey(payload),
    messageParams: getApiMessageParams(payload),
  };
}
